import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const PersonalInfoStep = ({ formData, errors, onChange }) => {
  const relationshipStatusOptions = [
    { value: 'married', label: 'Married' },
    { value: 'engaged', label: 'Engaged' },
    { value: 'long-term', label: 'Long-term Relationship' },
    { value: 'committed', label: 'Committed Partnership' }
  ];

  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'non-binary', label: 'Non-binary' },
    { value: 'prefer-not-to-say', label: 'Prefer not to say' }
  ];

  return (
    <div className="space-y-4 md:space-y-6">
      <div>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-2">
          Let's Get Started
        </h2>
        <p className="text-sm md:text-base text-muted-foreground">
          Tell us a bit about yourself. This information helps us personalize your experience.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="First Name"
          type="text"
          name="firstName"
          placeholder="Enter your first name"
          value={formData?.firstName}
          onChange={onChange}
          error={errors?.firstName}
          required
        />

        <Input
          label="Last Name"
          type="text"
          name="lastName"
          placeholder="Enter your last name"
          value={formData?.lastName}
          onChange={onChange}
          error={errors?.lastName}
          required
        />
      </div>
      <Input
        label="Email Address"
        type="email"
        name="email"
        placeholder="your.email@example.com"
        description="We'll use this to send you important updates"
        value={formData?.email}
        onChange={onChange}
        error={errors?.email}
        required
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Date of Birth"
          type="date"
          name="dateOfBirth"
          value={formData?.dateOfBirth}
          onChange={onChange}
          error={errors?.dateOfBirth}
          required
        />

        <Select
          label="Gender"
          options={genderOptions}
          value={formData?.gender}
          onChange={(value) => onChange({ target: { name: 'gender', value } })}
          error={errors?.gender}
          placeholder="Select your gender"
          required
        />
      </div>
      <Select
        label="Relationship Status"
        options={relationshipStatusOptions}
        value={formData?.relationshipStatus}
        onChange={(value) => onChange({ target: { name: 'relationshipStatus', value } })}
        error={errors?.relationshipStatus}
        placeholder="Select your relationship status"
        description="This helps us understand your relationship context"
        required
      />
      <Input
        label="Relationship Duration"
        type="text"
        name="relationshipDuration"
        placeholder="e.g., 5 years, 18 months"
        description="How long have you been together?"
        value={formData?.relationshipDuration}
        onChange={onChange}
        error={errors?.relationshipDuration}
      />
    </div>
  );
};

export default PersonalInfoStep;